import { Field, Int, ObjectType } from '@nestjs/graphql'
import { PublisherApplicationNoteDto } from './publisherApplicationNote.dto'

/**
 * A Publisher account's application as staff see it on User details [sc-29190]: the answers, whether it has
 * been reviewed and by whom, and the internal notes. No submittedDate means nothing was submitted: the
 * account was already on the plan when the Business Info step arrived, or has no application at all.
 */
@ObjectType()
export class AdminPublisherApplicationDto {
  @Field(t => Int)
  userId!: number

  @Field({ nullable: true })
  website?: string

  @Field({ nullable: true })
  information?: string

  @Field(t => Date, { nullable: true })
  submittedDate?: Date

  @Field(t => Date, { nullable: true })
  reviewedDate?: Date

  @Field({ nullable: true })
  reviewedByName?: string

  // Newest first.
  @Field(t => [PublisherApplicationNoteDto])
  notes!: PublisherApplicationNoteDto[]
}
